import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Download } from 'lucide-react';

const INVOICE_STATUS_COLORS = {
  draft: 'bg-gray-100 text-gray-700',
  sent: 'bg-blue-100 text-blue-700',
  paid: 'bg-green-100 text-green-700',
  overdue: 'bg-red-100 text-red-700',
};

export function InvoiceDetailDialog({ viewInvoice, onClose, getClientName, getFirmName, fmtCurrency, onDownloadPdf }) {
  return (
    <Dialog open={!!viewInvoice} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="invoice-detail-dialog">
        <DialogHeader><DialogTitle>Invoice Details</DialogTitle></DialogHeader>
        {viewInvoice && (
          <div className="space-y-4 text-sm">
            <div className="grid grid-cols-2 gap-3">
              <div><span className="text-muted-foreground">Invoice #:</span><br /><span className="font-semibold">{viewInvoice.invoice_number}</span></div>
              <div><span className="text-muted-foreground">Status:</span><br /><Badge className={`text-xs ${INVOICE_STATUS_COLORS[viewInvoice.status]}`}>{viewInvoice.status}</Badge></div>
              <div><span className="text-muted-foreground">Client:</span><br /><span className="font-medium">{getClientName(viewInvoice.client_id)}</span></div>
              <div><span className="text-muted-foreground">Firm:</span><br />{getFirmName(viewInvoice.firm_id) || '-'}</div>
              <div><span className="text-muted-foreground">Invoice Date:</span><br />{viewInvoice.invoice_date || '-'}</div>
              <div><span className="text-muted-foreground">Due Date:</span><br />{viewInvoice.due_date || '-'}</div>
              <div><span className="text-muted-foreground">Period:</span><br />{viewInvoice.service_period || '-'}</div>
            </div>
            <div><span className="text-muted-foreground">Description:</span><p className="mt-1">{viewInvoice.service_description || '-'}</p></div>
            <div className="border rounded-lg p-3 bg-muted/30 space-y-2">
              <div className="flex justify-between"><span className="text-muted-foreground">Amount</span><span>Rs. {fmtCurrency(viewInvoice.amount)}</span></div>
              {viewInvoice.cgst_amount != null && <div className="flex justify-between"><span className="text-muted-foreground">CGST ({viewInvoice.cgst_rate}%)</span><span>Rs. {fmtCurrency(viewInvoice.cgst_amount)}</span></div>}
              {viewInvoice.sgst_amount != null && <div className="flex justify-between"><span className="text-muted-foreground">SGST ({viewInvoice.sgst_rate}%)</span><span>Rs. {fmtCurrency(viewInvoice.sgst_amount)}</span></div>}
              {viewInvoice.igst_amount != null && viewInvoice.igst_amount > 0 && <div className="flex justify-between"><span className="text-muted-foreground">IGST ({viewInvoice.igst_rate}%)</span><span>Rs. {fmtCurrency(viewInvoice.igst_amount)}</span></div>}
              <div className="flex justify-between border-t pt-2 font-semibold text-teal-700"><span>Invoice Value</span><span>Rs. {fmtCurrency(viewInvoice.invoice_value ?? viewInvoice.amount)}</span></div>
            </div>
            <Button className="w-full" variant="outline" onClick={() => onDownloadPdf(viewInvoice)} data-testid="invoice-detail-pdf"><Download className="h-4 w-4 mr-2" /> Download PDF</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
